import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

const DeleteDialog = ({ open, onClose, onConfirm }) => {
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    onConfirm(reason);
    setReason('');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <FormattedMessage id="Confirm Delete" />
      </DialogTitle>

      <DialogContent>
        <p>
          <FormattedMessage id="Are you sure" />
        </p>

        <TextField
          label={<FormattedMessage id="Reason for deletion" />}
          multiline
          rows={3}
          fullWidth
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          margin="dense"
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            bgcolor: 'transparent',
            color: '#292D32',
            borderRadius: '0px',
            border: '1px solid #292D32',
          }}
        >
          <FormattedMessage id="No" />
        </Button>

        <Button
          onClick={handleConfirm}
          sx={{
            bgcolor: '#292D32',
            color: '#FFFFFF',
            borderRadius: '0px',
            border: '1px solid #292D32',
            '&:hover': { bgcolor: '#292D32' },
          }}
        >
          <FormattedMessage id="Yes" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
